// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSocialMediaLinkedIn_root__eb7Th","outer":"IconSocialMediaLinkedIn_outer__3cyiV","g":"IconSocialMediaLinkedIn_g__1JuMH","inner":"IconSocialMediaLinkedIn_inner__2PmUR"};